import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { UpdateDashboardSeenNotification } from '@api/store/dashboardSeenNotifications/actions';
import { getNotificationStore } from '@api/store/notifications/actions';
import { PersonaSurveyDialogBody } from './components/PersonaSurveyDialogBody';
import { findPersonaSurveyNotificationName } from './tools/findPersonaSurveyNotificationName';
import { getPersonaSurveyUrl } from './tools/getPersonaSurveyUrl';

export const usePersonaSurveyDialog = () => {
    const { t } = useTranslation();
    const { notificationList } = useSelector(getNotificationStore);
    const dispatch = useDispatch();
    const notificationName = findPersonaSurveyNotificationName(notificationList);

    const getConfig = () => ({
        body: <PersonaSurveyDialogBody />,
        title: t('shareyourinsightsget25giftcard'),
        confirmLabel: t('takemetothesurvey'),
        cancelLabel: t('notinterested'),
        onClickConfirm: (): void => {
            if (!notificationName) {
                return;
            }
            window.open(getPersonaSurveyUrl(notificationName), '_blank');
            dispatch(UpdateDashboardSeenNotification(notificationName));
        },
        onClickCancel: (): void => {
            if (!notificationName) {
                return;
            }
            dispatch(UpdateDashboardSeenNotification(notificationName));
        },
        fullScreen: false,
    });

    return { getConfig };
};
